module.exports = __webpack_public_path__ + "media/images/projects/project_banner_mobile-89c911212e5a36acee6a60ab902bf072.jpg";